<form [formGroup]="addListsForm">
    <div class="uk-width-expand uk-padding-remove input-div">
      <input
        class="uk-input task-input-field"
        placeholder="Enter name"
        formControlName="list"
      />
      <div class="input-border"></div>
    </div>
  </form>